import GlobalFooter from './src/main';
export default GlobalFooter;